import { API_URLS } from '@helpers/api';
import { useForm } from '@hooks/useForm';
import Button from '@stories/Components/Buttons/Button/Button';
import CtaLink from '@stories/Components/Buttons/CtaLink/CtaLink';
import CheckboxField from '@stories/Components/FormFields/CheckboxField/CheckboxField';
import TextField from '@stories/Components/FormFields/TextField/TextField';
import LoadingIndicator from '@stories/Components/Misc/LoadingIndicator/LoadingIndicator';
import qs from 'query-string';
import React from 'react';
import { StringParam, useQueryParams } from 'use-query-params';
import { BookEventFormStyles } from '../../BookEventForm.styles';
import { StepThreeStyles as S } from './StepThree.styles';
const StepThree = ({ stepProps, activeStep, step, setActive, submit, response }) => {
    const { refContainer, status: formStatus, serverErrors, confirmationMessage: formConfirmationMessage, onSubmit, useReactHookFormReturn: { register, formState: { errors, dirtyFields }, watch, setError, setValue, }, } = useForm({
        defaultValues: {
            step: 4,
            attendees: stepProps.attendees ?? [],
            code: '',
            eventId: stepProps.eventId,
        },
        endpoint: API_URLS.SUBMIT_BOOK_EVENT,
        mode: 'json',
    });
    const [params] = useQueryParams(Object.assign({
        success: StringParam,
        bookingId: StringParam,
        // cId: StringParam,
        // mId: StringParam,
        // mBandId: StringParam,
        // hash: StringParam,
    }));
    React.useEffect(() => {
        if (params.success) {
            setValue('success', params.success);
            setActive(3);
            // Timeout is necessary for scroll to trigger
            setTimeout(() => {
                refContainer.current?.scrollIntoView({ behavior: 'smooth' });
            }, 150);
        }
        if (params.bookingId)
            setValue('bookingId', params.bookingId);
        // if (params.cId) setValue('contactId', params.cId);
        // if (params.mId) setValue('membershipId', params.mId);
        // if (params.mBandId) setValue('membershipBandId', params.mBandId);
        // if (params.hash) setValue('hash', params.hash);
    }, [qs.stringify(params)]);
    React.useEffect(() => {
        if (stepProps.code)
            setValue('code', stepProps.code);
    }, [stepProps.code]);
    const [error, setGeneralError] = React.useState();
    React.useEffect(() => {
        if (response?.errors) {
            const errors = response.errors;
            if (errors) {
                return setGeneralError({ message: Object.values(errors).join('. '), type: 'server' });
            }
        }
        setGeneralError(undefined);
    }, [response]);
    React.useEffect(() => {
        setValue('attendees', stepProps.attendees ?? []);
    }, [stepProps.attendees]);
    const formData = watch();
    return (React.createElement(S.Container, { ref: refContainer },
        React.createElement(BookEventFormStyles.FormStepTitle, { disabled: activeStep <= step, onClick: () => setActive(step === activeStep ? 0 : step) },
            "3. ",
            stepProps.title),
        React.createElement(BookEventFormStyles.FormContent, { isActive: step === activeStep },
            React.createElement(BookEventFormStyles.FormContentInner, null, (formStatus === 'fulfilled' && formConfirmationMessage) ||
                (params.success === 'True' && stepProps.confirmationMessage) ? (React.createElement(React.Fragment, null,
                formConfirmationMessage && (React.createElement(S.Description, { dangerouslySetInnerHTML: { __html: formConfirmationMessage } })),
                stepProps.confirmationTitle && (React.createElement(S.ConfirmationTitle, null, stepProps.confirmationTitle)),
                stepProps.confirmationMessage && (React.createElement(S.Description, { dangerouslySetInnerHTML: { __html: stepProps.confirmationMessage } })))) : (React.createElement(React.Fragment, null,
                serverErrors &&
                    serverErrors.map((error, i) => (React.createElement(BookEventFormStyles.FormError, { key: `servererror-${i}` }, error))),
                response && response.data?.totalPrice && (React.createElement(S.TotalPrice, null,
                    "Order Total:",
                    ' ',
                    React.createElement("span", { "data-discounted": !!response.data.totalPriceDiscounted }, response.data.totalPrice),
                    response.data.totalPriceDiscounted && (React.createElement(React.Fragment, null,
                        ' ',
                        React.createElement("span", null, response.data.totalPriceDiscounted))))),
                stepProps.failureMessages && (React.createElement(BookEventFormStyles.FormError, null,
                    stepProps.failureMessages[0],
                    stepProps.failureMessages.length > 1 ? ` (${stepProps.failureMessages[1]})` : '')),
                React.createElement(S.Description, null,
                    React.createElement("p", null, stepProps.description)),
                React.createElement(S.Form, { onSubmit: onSubmit },
                    React.createElement(BookEventFormStyles.Field, { "data-promo": true },
                        React.createElement(TextField, { dirty: dirtyFields?.code ?? false, error: errors?.code && errors.code.message ? errors.code : error, inputProps: register(`code`), label: "Promo code", placeholder: "Enter promo code" }),
                        React.createElement(Button, { buttonType: "blue-solid", onClick: (e) => {
                                e.preventDefault();
                                const value = formData.code;
                                if (!value) {
                                    return setError('code', { message: 'Please enter a promo code' });
                                }
                                else {
                                    setError('code', {});
                                    submit({
                                        code: value,
                                        attendees: formData.attendees,
                                    });
                                }
                            } },
                            "Apply ",
                            React.createElement("span", null, "Code"))),
                    React.createElement(BookEventFormStyles.ExternalLabel, null, "TICK the box(es) if you would like:"),
                    React.createElement(BookEventFormStyles.Field, null,
                        React.createElement(CheckboxField, { checkboxLabel: `I agree that the information I have filled in is genuine`, dirty: dirtyFields?.disclaimer ?? false, error: errors?.disclaimer, inputProps: register(`disclaimer`, {
                                required: 'Please confirm that the information you have filled in is genuine',
                            }), size: "large" })),
                    React.createElement(BookEventFormStyles.Field, null,
                        React.createElement(CheckboxField, { checkboxLabel: `I’ve read and agree with the <a href="${stepProps.termsUrl}" target="_blank">terms & conditions</a>`, dirty: dirtyFields?.termsAndConditions ?? false, error: errors?.termsAndConditions, inputProps: register(`termsAndConditions`, {
                                required: 'Please confirm that you have read and agree with the terms & conditions',
                            }), size: "large" })),
                    React.createElement(BookEventFormStyles.StepBottom, null,
                        React.createElement(CtaLink, { as: "button", onClick: (e) => {
                                e.preventDefault();
                                setActive(2);
                            } }, "Back to Step 2"),
                        React.createElement(Button, { buttonType: "orange-solid" }, "Confirm Booking"))))))),
        formStatus === 'pending' && React.createElement(LoadingIndicator, { label: "Submitting\u2026", layout: "fixed" })));
};
export default StepThree;
